<script setup>
import { Head, Link, useForm } from '@inertiajs/vue3'
import Checkbox from 'primevue/checkbox';

const props = defineProps({
    groupedPermissions: Array,
    role: Object
});
const form = useForm({
    name: props.role.name,
    permissions: props.role.permissions.map(permission => permission.id)
});
function submit() {
    form.post('/portal/rollen/' + props.role.id + '/edit', {
        onSuccess: () => {
            form.reset();
        }
    });
}
function translatePermission(permission) {
    //remove everything before the -
    permission = permission.split('-').pop();

    switch (permission) {
        case 'store':
            return 'Aanmaken';
        case 'index':
            return 'Overzicht';
        case 'update':
            return 'Bewerken';
        case 'destroy':
            return 'Verwijderen';
        case 'show':
            return 'Bekijken';
        case 'map':
            return 'Kaart';
        case 'accept_login':
            return 'Inloggen accepteren';
        case 'accept_login':
            return 'Inloggen accepteren';
        case 'accept':
            return 'Accepteren';
        case 'place_bid':
            return 'Bod plaatsen';
        case 'remove_bid':
            return 'Bod verwijderen';
        case 'place_comment':
            return 'Comment plaatsen';
        case 'edit_question':
            return 'Vragen aanpassen';
        case 'register':
            return 'Auto aanmelden';
        case 'fees':
            return 'Fees';
        case 'options':
            return 'Opties';
        case 'preferences':
            return 'Voorkeuren';
        case 'conditions':
            return 'Condities';
    }
}
</script>

<template>
    <Head title="Rol aanpassen | Mijnautosnelweg" />
    <form class="px-4 sm:px-6 py-6 space-y-12" @submit.prevent="submit">
        <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
            <div>
                <h2 class="text-base font-semibold leading-7 text-gray-900">Rol informatie</h2>
                <p class="mt-1 text-sm leading-6 text-gray-600">Voer hier de naam in.</p>
            </div>
            <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div class="col-span-full">
                    <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Naam
                    </label>
                    <div class="mt-2">
                        <input type="text" name="name" id="name" autocomplete="name" v-model="form.name"
                            class="input-style" />
                    </div>
                    <div class="text-red-500" v-if="form.errors.name">{{ form.errors.name }}</div>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
            <div>
                <h2 class="text-base font-semibold leading-7 text-gray-900">Permissies</h2>
                <p class="mt-1 text-sm leading-6 text-gray-600">Stel hier in wat de verkoper wel en niet mag zien op
                    het portaal</p>
            </div>
            <div class="space-y-10 md:col-span-2">
                <div class="flex flex-col gap-x-8 gap-y-10 pb-12">
                    <fieldset v-for="(groupedPermission, index) in props.groupedPermissions">
                        <legend class="text-sm font-semibold leading-6 text-gray-900">{{ index }}</legend>
                        <div class="flex flex-wrap mt-4 gap-2">
                            <div class="relative flex gap-x-3" v-for="permission in groupedPermission.permissions">

                                <Checkbox v-model="form.permissions" :value="permission.id"
                                    :inputId="'permission_' + permission.id" class="hidden" />
                                <!-- <div class="text-sm leading-6">
                                    <label for="comments" class="font-medium text-gray-900">{{permission.permission}}</label>
                                </div> -->
                                <label :for="'permission_' + permission.id"
                                    :class="form.permissions.includes(permission.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                                    class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                                    translatePermission(permission.permission) }}</label>
                            </div>
                        </div>
                    </fieldset>
                    <div class="text-red-500" v-if="form.errors.permissions">{{ form.errors.permissions }}</div>
                </div>
            </div>
        </div>
        <div class="mt-6 flex items-center justify-end gap-x-6">
            <Link href="/portal/rollen" type="button" class="text-sm font-semibold leading-6 text-gray-900">Annuleren
            </Link>
            <button type="submit"
                class="rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brightorange">Opslaan</button>
        </div>
    </form>
</template>